
import {Component} from './base';

export class WebhookFormComponent extends Component {
  public static shouldLoad() {
    return $('#new-webhook-form,#edit-webhook-form').length > 0;
  }

  public load() {
    this.nextStep(1);

    $('.provider-option').on('click', (selector) => {
      let value = $(selector.currentTarget).data('value') as string;
      $('#form_provider').val(value);

      this.nextStep(2);
    });

    $('.type-option').on('click', (selector) => {
      let value = $(selector.currentTarget).data('value') as string;
      $('#form_type').val(value);

      if (value === 'remind' || value === 'both') {
        this.nextStep(3);
      } else {
        this.nextStep(4);
      }
    });

    $('#remind-continue').on('click', (selector) => {
      let hasAny = $('#form_remindTime input:checked').length > 0;

      $('#form_remindTime, .remind-select > div').removeClass('has-error has-feedback');
      $('.remind-feedback').collapse('hide');

      if (!hasAny) {
        $('#form_remindTime, .remind-select > div').addClass('has-error has-feedback');
        $('.remind-feedback').collapse('show');
        return;
      }

      this.nextStep(4);
    });

    // Instructions panel.
    $('.instructions-container .instruction-step:first-child').collapse('show');
    $('.instructions-container .instructions-next').on('click', (selector) => {
      let container = $(selector.currentTarget).parents('.instructions-container');
      let activeNr = parseInt(container.find('.instruction-step.collapse.in').data('step') as string);
      if (activeNr === 4) {
        // Validate URL.
        let reg = /^https:\/\/discord(?:app)*.com\/api\/webhooks\/[0-9]+\/[^\/]+$/;
        let url = $('#form_url').val() as string;
        let matches = reg.exec(url);

        if (! matches) {
          alert('The url you entered is not valid!');
        } else {
          this.nextStep(5);
        }
        return;
      }

      container.find('.instruction-step').collapse('hide');
      container.find('.instruction-step-' + (activeNr + 1)).collapse('show');
    });

    // Custom mention.
    $('#form_mention input').on('click', (selector) => {
      let inputSelector = $(selector.currentTarget);
      let selectedInputValue = inputSelector.parents('.form-group').find('input:checked').val();
      if (selectedInputValue === 'custom') {
        $('.mention-custom').collapse('show');
      } else {
        $('.mention-custom').collapse('hide');
        $('.mention-custom input').val('');
      }
    });

    // Test Button
    $('#test-button').on('click', (selector) => {
      let url = $('#form_url').val() as string;
      let encodedUrl = btoa(url);
      let baseUrl = $('#test-base-url').val() as string;
      baseUrl = baseUrl.substring(0, baseUrl.length - 4);
      let testUrl = baseUrl + encodedUrl;

      $('.test-success').collapse('hide');

      $.ajax({
        url: testUrl,
        method: 'GET',
        success: data => {
          $('.test-success').collapse('show');
        },
        error: () => {
          alert('The url might be incorrect, we couldn\'t send the test message!');
        }
      });
    });

    // Extra Filters.
    $('#form_filter_titles_enable').on('click', (selector) => {
      $('#filter_titles_container').collapse($(selector.currentTarget).is(':checked') ? 'show' : 'hide');
    });
    $('#form_filter_styles_enable').on('click', (selector) => {
      $('#filter_styles_container').collapse($(selector.currentTarget).is(':checked') ? 'show' : 'hide');
    });
    $('#filter_titles_container').collapse($('#form_filter_titles_enable').is(':checked') ? 'show' : 'hide');
    $('#filter_styles_container').collapse($('#form_filter_styles_enable').is(':checked') ? 'show' : 'hide');
  }

  protected nextStep(step: number) {
    $('.step.in').collapse('hide');
    $('.step-' + step).collapse('show');
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/webhook.ts